import React from 'react';
import PropTypes from 'prop-types';
import { isValidExactUrl } from 'wix-rich-content-common';
import { officialEmotes } from '../official-emotes';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
var _React_Component;
class OfficialEmoteViewer extends (_React_Component = React.Component) {
    render() {
        const { componentData  } = this.props;
        const emoteCode = componentData.emote.trim();
        if (!officialEmotes[emoteCode]) {
            return null;
        }
        const emote = officialEmotes[emoteCode];
        return /*#__PURE__*/ React.createElement("img", {
            src: `https://e.deviantart.net/emoticons${emote.src}`,
            alt: emote.name,
            width: emote.width,
            height: emote.height,
            style: {
                imageRendering: 'pixelated'
            },
            loading: "lazy"
        });
    }
}
OfficialEmoteViewer.propTypes = {
    componentData: PropTypes.object.isRequired,
    theme: PropTypes.object
};
var _React_Component1;
class CommunityEmoteViewer extends (_React_Component1 = React.Component) {
    render() {
        const { componentData  } = this.props;
        if (!componentData.src) {
            return null;
        }
        if (componentData.url && isValidExactUrl(componentData.url)) {
            return /*#__PURE__*/ React.createElement("a", {
                href: cleanLinkSrc(componentData.url),
                title: componentData.title
            }, /*#__PURE__*/ React.createElement("img", {
                src: cleanLinkSrc(componentData.src),
                alt: componentData.title,
                width: componentData.width,
                height: componentData.height,
                loading: "lazy"
            }));
        }
        return /*#__PURE__*/ React.createElement("img", {
            src: cleanLinkSrc(componentData.src),
            alt: componentData.title,
            width: componentData.width,
            height: componentData.height,
            loading: "lazy"
        });
    }
}
CommunityEmoteViewer.propTypes = {
    componentData: PropTypes.object.isRequired,
    theme: PropTypes.object
};
export { OfficialEmoteViewer, CommunityEmoteViewer };
